import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';
import navigate from 'libs/router/navigate';

import BasicHeaderWithLogo from 'components/BasicHeaderWithLogo';
import ActionButton from 'components/buttons/action-button/ActionButton';
import ActionLink from 'components/buttons/action-link/ActionLink';
import Footer from 'components/footer/Footer';

import { EVENT_TYPE_MAINTENANCE, trackEvent } from 'modules/tracking/utils/tracking';

applyTranslations(require('./i18n/maintenance-layout.i18n.json'));

class MaintenanceLayout extends React.PureComponent<{}> {
  componentDidMount(): void {
    trackEvent(EVENT_TYPE_MAINTENANCE);
  }

  handleReload = () => {
    navigate.reload();
  };

  render(): React.ReactNode {
    return (
      <section>
        <BasicHeaderWithLogo />
        <div className="layout-page layout-page--maintenance">
          <section
            className="maintenance"
            data-qa="maintenance"
          >
            <div className="maintenance__images">
              <div className="maintenance__image maintenance__image--plant" />
              <div className="maintenance__image maintenance__image--water" />
              <div className="maintenance__image maintenance__image--spray-bottle" />
            </div>
            <div className="maintenance__message">
              <div>
                {__t('maintenance_layout.message_line_1')}
              </div>
              <div>
                {__t('maintenance_layout.message_line_2')}
              </div>
            </div>
            <div className="maintenance__action">
              <ActionButton
                color="secondary"
                onClick={this.handleReload}
              >
                {__t('maintenance_layout.button_reload')}
              </ActionButton>
            </div>
            <div className="maintenance__footer">
              <div>
                {`${__t('maintenance_layout.message_footer')} `}
                <ActionLink
                  inline
                  size="inherit"
                  link={`mailto:${__t('maintenance_layout.message_footer_email')}`}
                >
                  {__t('maintenance_layout.message_footer_email')}
                </ActionLink>
              </div>
            </div>
          </section>
        </div>
        <Footer />
      </section>
    );
  }
}

export default MaintenanceLayout;
